import classNames from 'classnames';
import { useContext } from 'react';
import CollectionDataSource from '../../../../CollectionSettingsComponents/CollectionDataSource';
import styles from '../CollectionSettings.module.css';
import { CollectionSettingsIntegrationContext } from '../contextProvider';

function DataSetup() {
  const integration = useContext(CollectionSettingsIntegrationContext);

  return (
    <div className={classNames(styles.containerItem, styles.containerWithSidebar, 'p-6')}>
      <div className={classNames('is-size-4 with-text-color mb-5')}>Data Setup</div>

      <CollectionDataSource integration={integration} />
    </div>
  );
}

export default DataSetup;
